import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import NoteReader from '../Note.reader';
import NoteInput from './NoteInput';
import NoteDisplay from './NoteDisplay';
var NoteEditor = function NoteEditor(props) {
  if (NoteReader.showEditor(props)) {
    var buttonLabel = NoteReader.getButtonLabel(props);
    return /*#__PURE__*/React.createElement(NoteInput, _extends({}, props, {
      buttonLabel: buttonLabel
    }));
  }
  return /*#__PURE__*/React.createElement(NoteDisplay, props);
};
export default NoteEditor;